import { type ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

interface AppLayoutProps {
  children: ReactNode;
  showHeader?: boolean;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="mx-auto w-full max-w-full px-4 py-6 flex-1">{children}</main>
      <Footer />
    </div>
  );
};
